import {useMap} from '@vis.gl/react-google-maps';
import {useTrip} from '../../context/TripContext';
import {useEffect} from 'react';
import metaDataService from '../../../services/MetaDataService';
import {defer} from '../../../utils/Timing';
import {Events, EventType} from '../../../events/Events';
import {LatLng, Poi} from '../../../react-app-env';
import {calculateInitialBounds} from '../utils/InitialBoundsCalculator';
import {Breakpoint, getBreakpoint} from '../../../utils/Breakpoint';

function MapBehaviour() {
  const map = useMap();
  const trip = useTrip();

  // Initialise map once it becomes available
  useEffect(() => {
    if (map) {
      metaDataService.setGoogleMapsApi(map);

      defer(() => {
        Events.publish(EventType.SHOW_TRIP_IN_MAP);
      });
    }
  }, [map]);

  // Watch for SHOW_TRIP_IN_MAP events.
  useEffect(() => {
    const subscription = Events.subscribe(EventType.SHOW_TRIP_IN_MAP, () => {
      const coords = trip.pois.map((poi: Poi) => poi.location);
      const fittedBounds = calculateInitialBounds(coords);
      map?.panTo(fittedBounds.center);
      map?.setZoom(fittedBounds.zoom);
    });
    return () => subscription.unsubscribe();
  }, [map, trip]);

  // Watch for CENTER_IN_MAP events.
  useEffect(() => {
    const subscription = Events.subscribe(EventType.CENTER_IN_MAP, (location: LatLng) => {
      // If we're showing the Sidebar, offset the longitude a bit to account for that
      let lngOffset = 0;
      if (getBreakpoint() !== Breakpoint.PHONE) {
        lngOffset = 0.001;
      }

      map?.panTo({
        lat: location.lat,
        lng: location.lng - lngOffset
      });
      map?.setZoom(18);
    });

    return () => subscription.unsubscribe();
  }, [map]);

  // This behavioral component doesn't actually render anything
  return null;
}

export default MapBehaviour;
